export const REGEX_WHOLE_NUMBER = /^[0-9]+$/g

export const REGEX_NUMBER = /^[0-9]+(\.[0-9]+)?$/g
